<template>
<div class="images-slider__image" :class="{ 'images-slider__image--not-draggable': !draggable }">
	<img :draggable="draggable"
	     @dragstart="onDragStart"
	     @dragenter="onDragEnter"
	     @dragleave="onDragLeave"
	     @dragend="onDragEnd"
	     :src="imageUrl" />

	<div class="images-slider__image__price">
		&euro; {{ price }}
	</div>
</div>
</template>
<script>
export default {
	data: () => ({}),
	props: {
		imageUrl: {
			type: String,
			required: true
		},
		id: {
			type: Number,
			required: true
		},
		price: {
			type: Number|String,
			default: 100
		},
		draggable: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		onDragStart(event) {
			if(!this.draggable) {
				return;
			}

			// originalTarget for firefox, srcElement for the other browsers
			const originalTarget = event.originalTarget || event.srcElement;

			const pageOffset = this.getRelativeDocumentPosition(originalTarget);

			const centerX = pageOffset.left + originalTarget.offsetWidth / 2;
			const centerY = pageOffset.top + originalTarget.offsetHeight / 2;

			const json = {
				offset: {
					x: centerX - (event.clientX + this.getScrollLeft()),
					y: centerY - (event.clientY + this.getScrollTop())
				},
				id: this.id
			};

			event.dataTransfer.setData('json', JSON.stringify(json));
		},
		onDragEnter(event) {
			//event.preventDefault();
		},
		onDragOver(event) {
			//event.preventDefault();
		},
		onDragLeave(event) {
			//console.log(event);
		},
		onDragEnd(event) {
			//console.log(event);
		},
		/* https://plainjs.com/javascript/styles/get-the-position-of-an-element-relative-to-the-document-24/ */
		getRelativeDocumentPosition(element) {
			const rect = element.getBoundingClientRect(),
				scrollLeft = this.getScrollLeft(),
				scrollTop = this.getScrollTop();
			return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
		},
		getScrollLeft() {
			return window.pageXOffset || document.documentElement.scrollLeft;
		},
		getScrollTop() {
			return window.pageYOffset || document.documentElement.scrollTop;
		}

	}
}
</script>
<style lang="scss" scoped>

$price_length: 70px;

.images-slider {
    &__image {
		-webkit-touch-callout: none; /* iOS Safari */
    	-webkit-user-select: none; /* Safari */
     	-khtml-user-select: none; /* Konqueror HTML */
       	-moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */

        float: left;
        border-radius: 5px;
        background-color: rgb(245, 245, 250);
        box-shadow: 0 0 5px 0 rgba(0,0,0,0.10);
        margin: 20px;
		position: relative;

		&--not-draggable {
			.images-slider__image__price {
				background-color: #ff5454;
			}
		}

		&__price {
			position: absolute;
			right: -30px;
			top: -20px;
			height: $price_length;
			width: $price_length;
			border-radius: $price_length;
			// background-color: #175262;
			background-color: #63bf3f;
			color: #fff;
			line-height: $price_length;
			text-align: center;
			font-size: 18px;
		}

        img {
            // height: 200px;
			// width: 200px;
			height: 170px;
            width: 170px;

			&[draggable="false"] {
				pointer-events: none;
				opacity: 0.2;
			}

        }
    }
}
</style>



// WEBPACK FOOTER //
// assets/vue/apps/participate/playset-image.vue